import { createReducer } from 'redux-act';
import {
  COUNTRIES_FETCH_DATA_INIT,
  COUNTRIES_FETCH_DATA_SUCCESS,
  COUNTRIES_FETCH_DATA_FAIL,
  COUNTRIES_DELETE_COUNTRY_INIT,
  COUNTRIES_DELETE_COUNTRY_SUCCESS,
  COUNTRIES_DELETE_COUNTRY_FAIL,
  COUNTRIES_CREATE_COUNTRY_INIT,
  COUNTRIES_CREATE_COUNTRY_SUCCESS,
  COUNTRIES_CREATE_COUNTRY_FAIL,
  COUNTRIES_MODIFY_COUNTRY_INIT,
  COUNTRIES_MODIFY_COUNTRY_SUCCESS,
  COUNTRIES_MODIFY_COUNTRY_FAIL,
  COUNTRIES_CLEAN_UP,
} from '../../actions/countries';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
};

export const countriesReducer = createReducer(
  {
    [COUNTRIES_FETCH_DATA_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [COUNTRIES_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.data,
      loading: false,
      error: null,
    }),
    [COUNTRIES_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [COUNTRIES_DELETE_COUNTRY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [COUNTRIES_DELETE_COUNTRY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter((elem) => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [COUNTRIES_DELETE_COUNTRY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [COUNTRIES_CREATE_COUNTRY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [COUNTRIES_CREATE_COUNTRY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload.country),
      loading: false,
      error: null,
      success: true,
    }),
    [COUNTRIES_CREATE_COUNTRY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [COUNTRIES_MODIFY_COUNTRY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [COUNTRIES_MODIFY_COUNTRY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.map((elem) => {
        if (elem.id === payload.country.id) {
          return {
            ...elem,
            name: payload.country.name,
            locale: payload.country.locale,
            createdAt: payload.country.createdAt,
          };
        }
        return elem;
      }),
      loading: false,
      error: null,
      success: true,
    }),
    [COUNTRIES_MODIFY_COUNTRY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [COUNTRIES_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
    }),
  },
  initialState
);
